import { Token } from "./api";
import {REFRESH_TOKEN_KEY, AUTH_TOKEN_KEY} from '../constants'

const namespace = "ct";

/**
 * LocalStorage utility class for namespaced key-value storage
 * Pattern: ct/{baseKey}/{key}
 * Example: ct/my-org-slug/123/applications_viewFilter
 */
export class LocalStorage {
  baseKey: string;
  sessionOnly: boolean;

  constructor(baseKey = "shared", sessionOnly = false) {
    this.baseKey = baseKey;
    this.sessionOnly = sessionOnly;
  }

  buildKey = (key: string) => `${namespace}/${this.baseKey}/${key}`;

  getItem = (key: string): string => {
    if (typeof window === "undefined") {
      return ""; // SSR safety
    }
    const storage = this.sessionOnly ? sessionStorage : localStorage;
    return storage.getItem(this.buildKey(key)) || "";
  };

  setItem = (key: string, value: string) => {
    if (typeof window === "undefined") {
      return; // SSR safety
    }
    const storage = this.sessionOnly ? sessionStorage : localStorage;
    storage.setItem(this.buildKey(key), value);
  };

  removeItem = (key: string) => {
    if (typeof window === "undefined") {
      return; // SSR safety
    }
    const storage = this.sessionOnly ? sessionStorage : localStorage;
    storage.removeItem(this.buildKey(key));
  };
}

export function setTokens(token: Token) {
    window.localStorage.setItem(REFRESH_TOKEN_KEY, token.refresh);
    window.localStorage.setItem(AUTH_TOKEN_KEY, token.auth);
}

export function clearTokens() {
    window.localStorage.removeItem(REFRESH_TOKEN_KEY);
    window.localStorage.removeItem(AUTH_TOKEN_KEY);
}

export function getTokens(): Token | null {
    const authToken = window.localStorage.getItem(AUTH_TOKEN_KEY)
    const refreshToken = window.localStorage.getItem(REFRESH_TOKEN_KEY)
    if(authToken && refreshToken) {
        return {
            refresh: refreshToken,
            auth:  authToken
        }
    }
    return null;  
}